import React from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Stack, Divider, useStyleConfig} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import {DownloadDocumentIcon} from '../../../components/icons'
import {remCalc} from '../../../theme/_utils'
import ProductTips from './product-tips'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import routingObject from '../../../utils/static-routes'
import useProductRegistrationHandler from '../../../custom-hooks/use-product-registration-handler'

const ProductDocumentation = ({product}) => {
    const {formatMessage} = useIntl()
    const styles = useStyleConfig('ProductDocumentation')
    const navigate = useNavigation()

    let productRegistrationLink = null
    if (product?.id) {
        productRegistrationLink = `${routingObject.PRODUCT_REGISTRATION_PATH}/select?text=${product?.id}`
    }
    const handleProductRegistrationClick = useProductRegistrationHandler(
        routingObject,
        productRegistrationLink,
    )

    return (
        <Flex {...styles.pDocContainer}>
            <Stack {...styles.pdfTipsStack}>
                <Button
                    {...styles.buttonPadding}
                    data-testid="product-documentation-button"
                    variant={'text-button'}
                    onClick={() =>
                        product?.c_subModelIdentifier &&
                        navigate(`/s/${product.c_subModelIdentifier}`)
                    }
                >
                    {formatMessage({
                        defaultMessage: 'Visit Instruction Manual',
                        id: 'product_detail.product_documentation.manual',
                    })}
                </Button>
                <DownloadDocumentIcon data-testid="download-icon" {...styles.downloadIcon} />
            </Stack>
            <Divider {...styles.pDocDivider} aria-orientation="vertical" role="separator" />
            <Stack {...styles.pdfTipsStack}>
                <Button
                    {...styles.buttonPadding}
                    data-testid="product-registration-button"
                    variant={'text-button'}
                    onClick={() => handleProductRegistrationClick()}
                >
                    {formatMessage({
                        defaultMessage: 'Register your product',
                        id: 'product_detail.product_documentation.register',
                    })}
                </Button>
                <Stack gap={remCalc(7)}>
                    <ProductTips />
                </Stack>
            </Stack>
        </Flex>
    )
}

ProductDocumentation.propTypes = {
    product: PropTypes.object,
}

export default ProductDocumentation
